import { executeRequest, Request } from '@jfs/network'
import { RootStore } from '../../data/store'
import { getNetworkResponseError, isStatusOK } from '../../util/utill'
import { sitConfig } from '../config'
import { sendEventApi } from '../sendEvent'
interface UpdatePaymentResponse {
  txnRefNo?: string
  transactionDate?: string
  customerBillerAccountId?: number
  // ... include other relevant fields from sample 1 or the complex structure from sample 2
  responseStatus?: {
    code: string
    message: string
  }
  responseObject?: any[]
}
const updatePaymentResponseParser = (data: any): UpdatePaymentResponse => {
  if (!data || (typeof data === 'string' && data.includes('<html>'))) {
    throw {
      code: 500,
      message: 'Payment update service is temporarily unavailable.',
    }
  }
  if (isStatusOK(data) && (data?.errorCode === 0 || data?.status === 'SUCCESS')) {
    const responseData = data?.data
    if (responseData?.responseStatus?.code === '000' && Array.isArray(responseData.responseObject)) {
      return responseData as UpdatePaymentResponse
    } else if (responseData && responseData.txnRefNo) {
      return responseData as UpdatePaymentResponse
    } else if (responseData?.responseStatus) {
      console.error('Update Payment API Application Error:', responseData.responseStatus)
      throw getNetworkResponseError(responseData)
    } else {
      console.error('API SUCCESS, but UNHANDLED PAYLOAD FORMAT. Raw Data:', data)
      return responseData || ({} as UpdatePaymentResponse)
    }
  } else {
    console.error('Update Payment API Response Failed Parsing:', data)
    throw (
      getNetworkResponseError(data?.data) || {
        code: data?.errorCode || -1,
        message: data?.message || 'An unexpected error occurred during payment update.',
      }
    )
  }
}
export const updatePaymentAPI = (tokens: any, requestBody: any) => {
  let config = sitConfig(tokens) as any
  config.headers['x-user-access-token'] = RootStore?.bcAppInfo?.userAccessToken
  config.headers['x-userid-token'] = RootStore?.bcAppInfo?.userIdentifier
  config.headers['x-jfsUserId'] = RootStore.BillPaymentAgentOnboard.tempCustomerData?.jfsUserId || ''
  config.headers['x-mobileNumber'] = RootStore.BillPaymentAgentOnboard.tempCustomerData?.mobileNumber || 'N/A'
  // config.headers['x-channel-user-id'] = RootStore.agent.agentInfo.agentUserLoginId || '1123766817865366323';
  config.headers['x-channel-user-id'] = RootStore.BillPaymentAgentOnboard.tempCustomerData?.jfsUserId || ''
  config.headers['x-intercept-gateway'] = 'SERVICE/JPB'
  const request: Request<{}> = {
    apiPath: 'jpb/v2/dsp/payment/updateStatus',
    method: 'POST',
    config: config,
    body: requestBody,
  }
  sendEventApi(tokens, request, { status: 'INITIATED' })
  return executeRequest(request)
    .then((data) => {
      console.log(data, 'Update Payment API Raw Response')
      return updatePaymentResponseParser(data)
    })
    .then((response) => {
      sendEventApi(tokens, request, { status: 'SUCCESS' })
      return response
    })
    .catch((err) => {
      sendEventApi(tokens, request, { status: 'FAILED', errorDescription: err })
      throw err
    })
}
